(function () {
  'use strict';

  function requestJson(url) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.timeout = 15000;
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) return;
        if (xhr.status < 200 || xhr.status >= 300) {
          reject(new Error('Review feed unavailable'));
          return;
        }
        try {
          resolve(JSON.parse(xhr.responseText));
        } catch (_error) {
          reject(new Error('Invalid review feed'));
        }
      };
      xhr.onerror = function () { reject(new Error('Review feed unavailable')); };
      xhr.ontimeout = function () { reject(new Error('Review feed timed out')); };
      xhr.send();
    });
  }

  function addText(parent, tagName, className, value) {
    var node = document.createElement(tagName);
    if (className) node.className = className;
    node.textContent = value || '';
    parent.appendChild(node);
    return node;
  }

  function initCarousel(card) {
    var slides = card.querySelectorAll('[data-nt-review-slide]');
    if (slides.length < 2) return;
    var dots = card.querySelectorAll('[data-nt-review-dot]');
    var current = card.querySelector('[data-nt-review-current]');
    var activeIndex = 0;
    var startX = 0;

    function show(nextIndex) {
      activeIndex = (nextIndex + slides.length) % slides.length;
      for (var index = 0; index < slides.length; index += 1) {
        var active = index === activeIndex;
        slides[index].hidden = !active;
        slides[index].classList.toggle('is-active', active);
        if (dots[index]) dots[index].classList.toggle('is-active', active);
      }
      if (current) current.textContent = String(activeIndex + 1);
    }

    card.querySelector('[data-nt-review-prev]').addEventListener('click', function (event) {
      event.stopPropagation();
      show(activeIndex - 1);
    });
    card.querySelector('[data-nt-review-next]').addEventListener('click', function (event) {
      event.stopPropagation();
      show(activeIndex + 1);
    });
    for (var dotIndex = 0; dotIndex < dots.length; dotIndex += 1) {
      (function (index) {
        dots[index].addEventListener('click', function (event) {
          event.stopPropagation();
          show(index);
        });
      })(dotIndex);
    }
    card.querySelector('.nt-review-media').addEventListener('touchstart', function (event) {
      startX = event.touches[0].clientX;
    }, { passive: true });
    card.querySelector('.nt-review-media').addEventListener('touchend', function (event) {
      var distance = event.changedTouches[0].clientX - startX;
      if (Math.abs(distance) > 45) show(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });
    show(0);
  }

  function createCard(review) {
    var media = Array.isArray(review.media) ? review.media.filter(function (item) {
      return item && item.url;
    }) : [];
    if (!review.id || !media.length) return null;

    var reviewId = 'submitted-' + String(review.id);
    var card = document.createElement('article');
    card.className = 'nt-review-card';
    card.dataset.ntReviewCard = '';
    card.dataset.ntReviewCustomer = review.customer || '';
    card.dataset.ntReviewPublishedAt = review.publishedAt || '';
    card.dataset.ntReviewHref = '/pages/reviews?review=' + encodeURIComponent(reviewId) + '#review-' + encodeURIComponent(reviewId);
    card.setAttribute('role', 'link');
    card.setAttribute('tabindex', '0');
    card.setAttribute('aria-label', 'View this customer review');

    var mediaWrap = document.createElement('div');
    mediaWrap.className = 'nt-review-media';
    for (var mediaIndex = 0; mediaIndex < media.length; mediaIndex += 1) {
      var item = media[mediaIndex];
      var isVideo = String(item.type || '').indexOf('video/') === 0;
      var slide = document.createElement(isVideo ? 'video' : 'img');
      slide.className = 'nt-review-slide' + (mediaIndex === 0 ? ' is-active' : '');
      slide.dataset.ntReviewSlide = '';
      slide.hidden = mediaIndex !== 0;
      if (isVideo) {
        slide.controls = true;
        slide.preload = 'metadata';
      } else {
        slide.alt = (review.product || 'NT FAIRING') + ' owner photo ' + (mediaIndex + 1);
        slide.loading = mediaIndex === 0 ? 'eager' : 'lazy';
        slide.decoding = 'async';
        if (mediaIndex === 0) {
          slide.addEventListener('load', function (event) {
            var image = event.currentTarget;
            card.classList.toggle('nt-review-card--portrait', image.naturalHeight > image.naturalWidth * 1.1);
          }, { once: true });
        }
      }
      slide.src = item.url;
      mediaWrap.appendChild(slide);
    }

    if (media.length > 1) {
      var previous = addText(mediaWrap, 'button', 'nt-review-arrow nt-review-arrow--prev', '\u2039');
      previous.type = 'button';
      previous.dataset.ntReviewPrev = '';
      previous.setAttribute('aria-label', 'Previous customer photo');
      var next = addText(mediaWrap, 'button', 'nt-review-arrow nt-review-arrow--next', '\u203a');
      next.type = 'button';
      next.dataset.ntReviewNext = '';
      next.setAttribute('aria-label', 'Next customer photo');
      var dots = document.createElement('div');
      dots.className = 'nt-review-dots';
      for (var dotIndex = 0; dotIndex < media.length; dotIndex += 1) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = dotIndex === 0 ? 'is-active' : '';
        dot.dataset.ntReviewDot = String(dotIndex);
        dot.setAttribute('aria-label', 'Show customer media ' + (dotIndex + 1));
        dots.appendChild(dot);
      }
      mediaWrap.appendChild(dots);
      var count = document.createElement('span');
      count.className = 'nt-review-count';
      var current = addText(count, 'b', '', '1');
      current.dataset.ntReviewCurrent = '';
      count.appendChild(document.createTextNode('/' + media.length));
      mediaWrap.appendChild(count);
    }
    card.appendChild(mediaWrap);

    var copy = document.createElement('div');
    copy.className = 'nt-review-copy';
    var stars = document.createElement('div');
    stars.className = 'nt-review-stars';
    var rating = Math.max(1, Math.min(5, Number(review.rating || 5)));
    stars.setAttribute('aria-label', rating + ' out of 5 stars');
    for (var starIndex = 1; starIndex <= 5; starIndex += 1) {
      addText(stars, 'span', starIndex > rating ? 'is-empty' : '', '\u2605');
    }
    addText(stars, 'em', '', rating.toFixed(1));
    copy.appendChild(stars);
    addText(copy, 'h3', '', review.title || 'Owner review');
    addText(copy, 'blockquote', '', review.review || '');
    addText(copy, 'span', 'nt-review-read-more', 'Read full review →');
    var footer = document.createElement('footer');
    addText(footer, 'span', '', review.customer || 'Verified owner');
    addText(footer, 'b', '', 'VERIFIED PURCHASE');
    addText(footer, 'small', '', review.product || 'NT FAIRING OWNER BUILD');
    copy.appendChild(footer);
    card.appendChild(copy);

    card.addEventListener('click', function (event) {
      var target = event.target;
      if (target.closest && target.closest('button, a, video, input, select, textarea, [controls]')) return;
      window.location.assign(card.dataset.ntReviewHref);
    });
    card.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      window.location.assign(card.dataset.ntReviewHref);
    });
    initCarousel(card);
    return card;
  }

  function selectReviews(payload, limit) {
    var reviews = payload && Array.isArray(payload.reviews) ? payload.reviews.slice() : [];
    reviews.sort(function (a, b) {
      return new Date(b.publishedAt || 0).getTime() - new Date(a.publishedAt || 0).getTime();
    });
    var seenCustomers = {};
    var seenContent = {};
    var selected = [];
    for (var index = 0; index < reviews.length && selected.length < limit; index += 1) {
      var review = reviews[index];
      var customerKey = String(review.customer || '').trim().toLowerCase();
      var contentKey = (String(review.title || '') + '|' + String(review.review || '')).trim().toLowerCase();
      if ((customerKey && seenCustomers[customerKey]) || (contentKey !== '|' && seenContent[contentKey])) continue;
      if (customerKey) seenCustomers[customerKey] = true;
      if (contentKey !== '|') seenContent[contentKey] = true;
      selected.push(review);
    }
    return selected;
  }

  function renderLatest(grid, payload) {
    var mobile = window.matchMedia && window.matchMedia('(max-width: 820px)').matches;
    var limit = Number(mobile ? grid.dataset.ntReviewLimitMobile : grid.dataset.ntReviewLimit) || (mobile ? 3 : 4);
    var reviews = selectReviews(payload, limit);
    var fragment = document.createDocumentFragment();
    var cardCount = 0;
    for (var index = 0; index < reviews.length; index += 1) {
      var card = createCard(reviews[index]);
      if (!card) continue;
      fragment.appendChild(card);
      cardCount += 1;
    }
    if (!cardCount) throw new Error('No publishable reviews');
    while (grid.firstChild) grid.removeChild(grid.firstChild);
    grid.appendChild(fragment);
    grid.dataset.ntReviewSource = 'v2-live';
    grid.dataset.ntReviewUpdatedAt = new Date().toISOString();
    grid.classList.add('is-live');
  }

  function refresh() {
    var grids = document.querySelectorAll('[data-nt-latest-reviews]');
    for (var index = 0; index < grids.length; index += 1) {
      (function (grid) {
        if (grid.dataset.ntHomeReviewsV2 === 'loading') return;
        grid.dataset.ntHomeReviewsV2 = 'loading';
        grid.setAttribute('aria-busy', 'true');
        var feed = grid.dataset.ntReviewFeed || '/apps/nt-community/gallery';
        requestJson(feed).catch(function () {
          var separator = feed.indexOf('?') === -1 ? '?' : '&';
          return requestJson(feed + separator + '_nt_retry=' + Math.floor(Date.now() / 60000));
        }).then(function (payload) {
          renderLatest(grid, payload);
          grid.dataset.ntHomeReviewsV2 = 'ready';
        }).catch(function () {
          grid.dataset.ntHomeReviewsV2 = 'fallback-current';
        }).then(function () {
          grid.removeAttribute('aria-busy');
        });
      })(grids[index]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    var grids = document.querySelectorAll('[data-nt-latest-reviews]');
    for (var index = 0; index < grids.length; index += 1) grids[index].dataset.ntHomeReviewsV2 = '';
    refresh();
  });
})();
